import { render, staticRenderFns } from "./unit-parameters.vue?vue&type=template&id=05f23ee7&scoped=true&"
import script from "./unit-parameters.vue?vue&type=script&lang=js&"
export * from "./unit-parameters.vue?vue&type=script&lang=js&"
import style0 from "./unit-parameters.vue?vue&type=style&index=0&id=05f23ee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f23ee7",
  null
  
)

export default component.exports